import { DialogClose, DialogHeader, DialogTitle } from '@qodo/design-system';
import { X } from 'lucide-react';
import { spawn } from 'utils/translations';
import { HeaderProps } from '../types';

export const Header = ({ title }: HeaderProps) => {
  const spawnHeader = spawn('components.multi-step-dialog');

  return (
    <DialogHeader className="px-[2.5rem] py-[1.5rem] rounded-tr-lg border-b border-neutral-600 flex flex-row items-center justify-between">
      <DialogTitle className="text-2xl font-medium leading-[120%]">
        {title}
      </DialogTitle>
      <DialogClose aria-label={spawnHeader('close-aria-label')}>
        <X className="size-4 stroke-neutral-400" />
      </DialogClose>
    </DialogHeader>
  );
};
